import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import { languages } from 'app/utils/supportedLanguages';
import { CustomizationPageRouteDispatchProps } from 'components/settings/containers/sections/satisfaction/dixaMessengerCustomizations';
import { RouteComponentProps } from 'hocs/router';

import { CustomizationPage } from './CustomizationPage';

export type CustomizationPageRouteOwnProps = {
  mode?: 'create' | 'edit';
} & RouteComponentProps<'settingsId' | 'language'>;

type CustomizationPageRouteProps = CustomizationPageRouteOwnProps &
  CustomizationPageRouteDispatchProps;

export function CustomizationPageRoute({
  loadDixaMessengerSettingsAllLevels,
  mode,
  onSubmit,
  params,
}: CustomizationPageRouteProps): JSX.Element | null {
  const { language: languageCode, settingsId } = params;

  useEffect(loadDixaMessengerSettingsAllLevels, [
    loadDixaMessengerSettingsAllLevels,
  ]);

  if (!languageCode || !mode) {
    throw new Error(
      `${CustomizationPageRoute.name} expects to have router params to have the "languageCode" field.`,
    );
  }

  const language = languages.find(
    ({ code }) => code === languageCode?.toLocaleLowerCase(),
  );

  if (!language) {
    return <Navigate to="/settings/satisfaction/email" />;
  }

  return (
    <CustomizationPage
      languageName={language.label || ''}
      settingsId={settingsId}
      mode={mode}
      onSubmit={onSubmit}
    />
  );
}
